import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit {

  contactForm: FormGroup;
  submitted: boolean;
  productsArr: any = [
    {
      id: 'goldol-5w30-10000sn-synthetic-engine-oil-uae',
      image: 'assets/img/Oil-Images/5W30-1.jpeg',
      metaTitle: '5W30 Synthetic Engine Oil in Sharjah | GOLDOL 10000SN',
      metaDescription: 'Shop high-quality 5W30 fully synthetic engine oil in Sharjah. GOLDOL 10000SN delivers superior protection, efficiency & smooth engine performance.',
      name: 'GOLDOL 5W30 10000SN Synthetic Engine Oil',
      description: 'Designed for high-performance engines, GOLDOL 5W30-10000SN provides superior protection against wear, sludge, and oxidation. Its advanced synthetic formula ensures smooth engine performance, improved fuel efficiency, and extended drain intervals, making it ideal for modern vehicles operating under demanding conditions.',
    },
    {
      id: 'goldol-10w-40-semi-synthetic-engine-oil-uae',
      image: 'assets/img/Oil-Images/10W40-1.jpeg',
      metaTitle: '10W40 Semi Synthetic Engine Oil UAE | GOLDOL High-Performance Lubricant',
      metaDescription: 'Get reliable 10W40 semi synthetic engine oil for petrol & diesel engines. GOLDOL offers balanced protection, fuel efficiency & engine longevity.',
      name: 'GOLDOL 10W40 Semi Synthetic Engine Oil',
      description: 'GOLDOL 10W40-10000SN is a semi-synthetic engine oil formulated to deliver exceptional wear protection and thermal stability. It maintains optimal viscosity across various temperatures, ensuring reliable engine performance, reduced friction, and enhanced engine longevity. Ideal for both gasoline and diesel engines.',
    },
    {
      id: 'goldol-20w50-5000SL-engine-oil-dubai-uae',
      image: 'assets/img/Oil-Images/20W50-1.jpeg',
      metaTitle: 'Buy 20W50 Engine Oil in Dubai | GOLDOL 5000SL High Performance',
      metaDescription: 'Discover premium 20W50 engine oil in Dubai with GOLDOL 5000SL – ideal for older engines. Smooth performance, wear protection, and extended engine life.',
      name: 'GOLDOL 20W50 5000SL Engine Oil',
      description: 'Built for heavy-duty applications, GOLDOL 20W50-5000 SL provides robust protection against high temperatures and engine stress. Its high-viscosity formula reduces oil consumption and protects against deposits, making it a great choice for older engines and extreme driving conditions.',
    },
    {
      id: 'goldol-super-toyota-engine-oil-5w30-uae',
      image: 'assets/img/Oil-Images/5W30-1.jpeg',
      metaTitle: 'Toyota 5W30 Engine Oil UAE | GOLDOL Super Synthetic Formula',
      metaDescription: 'Buy premium 5W30 engine oil for Toyota vehicles. GOLDOL Super offers superior performance, engine cleanliness & fuel economy across UAE.',
      name: 'GOLDOL Super Toyota Engine Oil 5W30',
      description: 'GOLDOL SUPER 5W30 is an ultra-premium synthetic oil designed for maximum engine efficiency and durability. Engineered with advanced additive technology, it enhances fuel economy, minimizes engine wear, and provides outstanding protection even under extreme conditions. Perfect for high-performance and luxury vehicles.',
    }
  ];

  constructor(private fb: FormBuilder, private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Leading Lubricant Oil Suppliers in Dubai | GOLDOL Lubricants');
    this.metaService.updateTag({ name: 'description', content: 'GOLDOL Lubricants is a certified manufacturer of premium industrial oils, greases, and lubricants. Trusted lubricant oil suppliers in Dubai offering engine oil, industrial lubricants & more. ' });
    this.metaService.updateTag({ name: 'keywords', content: 'lubricant oil suppliers dubai' });
    this.contactForm = this.fb.group({
      name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
      email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      phone: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      message: ["", Validators.required],
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }
    return true;
  }

  get con(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    const data = {
      name: this.contactForm?.value?.name,
      email: this.contactForm?.value?.email,
      phone: this.contactForm?.value?.phone,
      message: this.contactForm?.value?.message,
    };

    // this.spinner.show();

    // // Make the API call with the constructed data object
    // this.apiCall.contactUsForm(data).subscribe({
    //   next: (response) => {
    //     this.spinner.hide();
    //     if (response.success) {
    //       this.common.showMessage("success", response.message);
    //       this.contactForm.reset();
    //       this.submitted = false;
    //     } else {
    //       this.common.showMessage("error", response.message);
    //     }
    //   },
    //   error: (error: any) => {
    //     this.spinner.hide();
    //     this.common.showMessage("error", error?.message);
    //   },
    // });
  }

}
